// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".criteria-chips .v-chip.v-chip--outlined.v-chip.v-chip[data-v-7ef939d1]{border-width:2px;border-left-width:6px;color:#000!important;background-color:hsla(0,0%,100%,.8)!important}.nlbr[data-v-7ef939d1]{white-space:pre-line}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
